/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { Zoom } from "react-awesome-reveal";
import Image from "next/image";

import AgapeSlider from "../../../../../../common/slider/AgapeSlider";
import Empty from "../../../static/Empty";

const useStyles = makeStyles((theme) => ({
  t1: {
    color: "#009693",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: 10,
    padding: 10,
  },
}));

const Video = ({ videos = [] }) => {
  const classes = useStyles();

  return (
    <Zoom triggerOnce delay={1000}>
      {videos.length > 0 ? (
        <Grid container alignItems="center">
          <Grid item xs={12}>
            <AgapeSlider
              listLength={videos.length}
              slidesToShowDesktop={1}
              slidesToShowTablet={1}
              slidesToShowMobile={1}
              arrow
              infinite
              // dots
            >
              {videos.map((item) => (
                <div
                  className={classes.div}
                  dir="rtl"
                  key={`videos-${item.id}`}
                >
                  <iframe
                    src={item.link}
                    frameborder="0"
                    style={{
                      width: "95%",
                      minHeight: "30vw",
                      margin: "1rem 2.5%",
                    }}
                    allowFullScreen
                  ></iframe>
                </div>
              ))}
            </AgapeSlider>
          </Grid>
        </Grid>
      ) : (
        <Empty />
      )}
    </Zoom>
  );
};

export default Video;
